import moment from 'moment';

// Match GrooveSell's transaction row legend, including its fraud-color priority.
export const transactionLegend = {
  sale: { label: 'Sale', color: '#ffffff', border: '#cbd5e1' },
  initial_payment: { label: 'Initial Payment', color: '#f2f3ff', border: '#b4b9f5' },
  rebill: { label: 'Rebill', color: '#edfff8', border: '#8fdcb9' },
  free: { label: 'Free Transaction', color: '#eff8ff', border: '#9ccdf3' },
  cancellation: { label: 'Cancellation', color: '#fffdea', border: '#e6d66a' },
  refund: { label: 'Refund', color: '#fff3f7', border: '#f5a3c4' },
  fraud: { label: 'Suspected Fraud', color: '#fff7e8', border: '#f0c470' },
  failed_rebill: { label: 'Failed Rebill', color: '#ffffff', border: '#cbd5e1' },
  unknown: { label: 'Status unavailable', color: '#ffffff', border: '#cbd5e1' },
};

export function presentRecentTransaction(transaction) {
  const code = Object.prototype.hasOwnProperty.call(transactionLegend, transaction.transaction_type_code)
    ? transaction.transaction_type_code : 'unknown';
  const status = transactionLegend[code];
  const flagged = Number(transaction.suspected_affiliate_fraud) === 1;
  const palette = flagged ? transactionLegend.fraud : status;
  const parsedDate = moment(transaction.date, ['DD MMM YYYY', 'MMMM D, YYYY'], 'en', true);
  const price = String(transaction.price || '');

  return {
    ...transaction,
    status: status.label,
    flagged,
    color: palette.color,
    border: palette.border,
    date: parsedDate.isValid() ? parsedDate.format('MMMM D, YYYY') : 'Date unavailable',
    price: code === 'refund' && price && !price.startsWith('-') ? `-${price}` : price,
    amountLabel: code === 'cancellation' ? 'Plan amount' : code === 'failed_rebill' ? 'Attempted amount' : '',
  };
}
